import {
  DocumentFraudAnalysisSettingsModel,
  FraudAnalysisVendorEnum,
} from '../../../../shared/models';

export const defaultFraudAnalysisSettings: DocumentFraudAnalysisSettingsModel =
  {
    vendor: FraudAnalysisVendorEnum.resistant_ai,
  };
